import { connect } from '@vfde-sails/core';
import { selectors as mapStateToProps } from 'Container/App/selector';
import * as priceActions from '../App/action';
import { resetForm } from '../AvailabilityCheck/action';
import { OverlayContent, FloatingButtonId, AppHtmlId } from '../../enums/elementId';
import { debugInfo } from '../../util/debug';
import { mountButton } from '../../components/button';
import { setAutoOverlayOpen } from '../../components/overlay';
import { getUpdateFlags } from './update';
import {
    mountSummaryCard,
    updateAlternativeOffer,
    updateSummaryCard,
    updateSummaryCardBusiness,
} from '../../components/summaryCard';

const mapDispatch = {
    ...priceActions,
    resetForm,
};

export type State = ReturnType<typeof mapStateToProps>;
export type Actions = typeof mapDispatch;

function container (_: State, actions: Actions) {
    const openAvc = () => {
        actions.openOverlay(OverlayContent.FORM);
        actions.resetForm();
    };

    const summaryCard = mountSummaryCard(AppHtmlId.SUMMARY_CARD);
    const altSummaryCard = mountSummaryCard(AppHtmlId.ALT_SUMMARY_CARD);
    const floatingMobileBtn = mountButton(FloatingButtonId.FLOATING_BUTTON, openAvc);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const {
                avcResult,
                preMarketingType,
                isAutoOverlayOpened,
            } = newState;

            const update = getUpdateFlags(newState, oldState);

            try {
                if (update.button && summaryCard) {
                    updateSummaryCardBusiness(summaryCard, newState, openAvc, floatingMobileBtn);
                }

                if (update.price && summaryCard) {
                    updateSummaryCard(summaryCard, newState);

                    setAutoOverlayOpen(actions, isAutoOverlayOpened);

                    // Note: Alternative Summary Card - Alternative offer for pre-marketing cases
                    const altTariffForPreMarketing = avcResult?.upsell ?? avcResult?.fastest;

                    altSummaryCard && updateAlternativeOffer(
                        altSummaryCard,
                        altTariffForPreMarketing,
                        preMarketingType,
                    );
                }
            } catch (error) {
                debugInfo(error);
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
